import React from 'react';

// Import logos directly here
import Brand2 from '../../assets/public-site/Brand2.png';
import image21 from '../../assets/public-site/image21.png';
import image22 from '../../assets/public-site/image22.png';
import image19 from '../../assets/public-site/image30.png';
import image20 from '../../assets/public-site/image31.png';

export const TrustedBrands: React.FC = () => {
  const brands = [
    { src: image22, alt: 'Brand 1' },
    { src: Brand2, alt: 'Brand 2' },
    { src: image19, alt: 'Brand 3' },
    { src: image20, alt: 'Brand 4' },
    { src: image21, alt: 'Brand 5' },
  ];

  return (
    <section className="bg-primary-200 py-10">
      <div className="container px-4 flex flex-col items-center text-center gap-6">
        <h2 className="text-2xl sm:text-3xl !leading-snug">
          Trusted by employers, cities, and changemakers shaping the future of work.
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6 mt-4">
          {brands.map((brand, index) => (
            <img
              key={index}
              src={brand.src}
              alt={brand.alt}
              className="h-20 sm:h-24 rounded-2xl object-contain mx-auto"
            />
          ))}
        </div>
      </div>
    </section>
  );
};
